const CoverageAmountByAgeBand = (age) => {
  const coverageAmountSpecs = {minCoverageAmount: 2000, maxCoverageAmount: null}
  if (age <= 55) {
    coverageAmountSpecs.maxCoverageAmount = 50000;
  } if (age >= 56 && age <= 65) {
    coverageAmountSpecs.maxCoverageAmount = 40000;
  } if (age >= 66 && age <= 75) {
    coverageAmountSpecs.maxCoverageAmount = 30000;
  } if (age >= 76) {
    coverageAmountSpecs.maxCoverageAmount = 25000;
  }

  return coverageAmountSpecs;
};

export default CoverageAmountByAgeBand;